import { render, staticRenderFns } from "./drawer-home-preview.vue?vue&type=template&id=5040bda0&scoped=true"
import script from "./drawer-home-preview.vue?vue&type=script&lang=js"
export * from "./drawer-home-preview.vue?vue&type=script&lang=js"
import style0 from "./drawer-home-preview.vue?vue&type=style&index=0&id=5040bda0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040bda0",
  null
  
)

export default component.exports